import script from "./CustomerSignature.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerSignature.vue?vue&type=script&setup=true&lang=js"

import "./CustomerSignature.vue?vue&type=style&index=0&id=7b2e3747&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b2e3747"]])

export default __exports__